import { render, staticRenderFns } from "./JoinedMeeting.vue?vue&type=template&id=228f7789&scoped=true&"
import script from "./JoinedMeeting.vue?vue&type=script&lang=js&"
export * from "./JoinedMeeting.vue?vue&type=script&lang=js&"
import style0 from "./JoinedMeeting.vue?vue&type=style&index=0&id=228f7789&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f7789",
  null
  
)

export default component.exports